// ⚠️ 必须使用 HashRouter，禁止改为 BrowserRouter（部署平台挂载在子路径下，BrowserRouter 无法匹配）
import { HashRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { HomePage } from "@/pages/HomePage";
import { DemoPage } from "@/pages/DemoPage";
import { ArchPage } from "@/pages/ArchPage";
import { FeatureMapPage } from "@/pages/FeatureMapPage";

export function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/demo" element={<DemoPage />} />
        <Route path="/arch" element={<ArchPage />} />
        <Route path="/map" element={<FeatureMapPage />} />
      </Routes>
      <Toaster position="top-center" />
    </HashRouter>
  );
}
